<template>
    <section class="bhub-section">
        <h2>{{ label }}</h2>
        <div v-html="description">
        </div>
    </section>
</template>
<script>
export default {
    props: {
        qid: Number,
        label: String,
        description: String,
    },
    data() {
        return {
        };
    },
};
</script>
